import React from 'react';
import { useSelector } from 'react-redux';
import CampaignBadge from '../../../../components/campaign-badge';
import { AppState } from '../../../../reducers';
import { Campaign } from '../../../../types';

type Props = {
  includedCampaigns?: number[];
  size?: 'small' | 'large';
};

const ActiveCampaignBadge = ({ includedCampaigns, size = 'small' }: Props) => {
  const activeCampaign = useSelector<AppState, Campaign | undefined>(state =>
    state.globals.campaigns.active.find((c: Campaign) => c.type === 'OFFER')
  );

  if (!activeCampaign?.id || !activeCampaign?.name) {
    return null;
  }

  if (
    includedCampaigns &&
    !includedCampaigns.map(String).includes(String(activeCampaign.id))
  ) {
    return null;
  }

  return <CampaignBadge campaign={activeCampaign} size={size} />;
};

export default ActiveCampaignBadge;
